import { proxy, useSnapshot } from 'valtio';
const notificationsStore = proxy({
    count: 0,
});
const setNotificationsCount = (count) => {
    notificationsStore.count = count;
};
export const useNotificationsStore = () => {
    const { count: notificationsCount } = useSnapshot(notificationsStore);
    return { notificationsCount, setNotificationsCount };
};
